import { render, staticRenderFns } from "./AS_HomePayment.vue?vue&type=template&id=59f4e431&scoped=true&"
var script = {}
import style0 from "./AS_HomePayment.vue?vue&type=style&index=0&id=59f4e431&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f4e431",
  null
  
)

export default component.exports